import { useCallback } from "react";
// eslint-disable-next-line no-restricted-imports
import { toast } from "sonner";
import Toast from "../components/Common/Toast";

const TOAST_DURATION = 5000;

export const useStatusToasts = () => {
  const addSuccessToast = useCallback(
    (message: string) =>
      toast.custom(
        id => (
          <Toast appearance="success" onDismiss={() => toast.dismiss(id)}>
            {message}
          </Toast>
        ),
        { duration: TOAST_DURATION },
      ),
    [],
  );

  const addErrorToast = useCallback(
    (message: string) =>
      toast.custom(
        id => (
          <Toast appearance="error" onDismiss={() => toast.dismiss(id)}>
            {message}
          </Toast>
        ),
        { duration: TOAST_DURATION },
      ),
    [],
  );

  const addWarningToast = useCallback(
    (message: string) =>
      toast.custom(
        id => (
          <Toast appearance="warning" onDismiss={() => toast.dismiss(id)}>
            {message}
          </Toast>
        ),
        { duration: TOAST_DURATION },
      ),
    [],
  );

  const addInfoToast = useCallback(
    (message: string) =>
      toast.custom(
        id => (
          <Toast appearance="info" onDismiss={() => toast.dismiss(id)}>
            {message}
          </Toast>
        ),
        { duration: TOAST_DURATION },
      ),
    [],
  );

  return { addSuccessToast, addErrorToast, addWarningToast, addInfoToast };
};
